var $b93cf9c16a1d6016$exports = {};
$b93cf9c16a1d6016$exports = {
    "colorSwatchPicker": `Fargekart`,
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};


export {$b93cf9c16a1d6016$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
